import * as actions from '@actions'
import { useCallback, useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import { Message } from '@components/shared/Message'

const SetPassword = () => {
    
    const [query] = useSearchParams()
    const navigate = useNavigate()
    
    const [user, setUser] = useState(null)
    const [token, setToken] = useState('')
    const [verified, setVerified] = useState(false)
    const [message, setMessage] = useState(null)
    
    const formik = useFormik({
        initialValues: { password: '', confirmPassword: '', orgCode: '', addOrg: '' },
        onSubmit: async values => {
            let errorMessage = null
            const passwordRegex = new RegExp('^(((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{8,})')
            
            if (!values.password || !values.confirmPassword)
                errorMessage = 'Please fill in all the fields.'
            else if (values.password !== values.confirmPassword)
                errorMessage = 'Password and confirm password does not match.'
            else if (!passwordRegex.test(values.password))
                errorMessage = 'Password does not meet the requirements.'
            
            // else if (!values.orgCode && !values.addOrg)
            //     errorMessage = 'Enter a organization code or add a new organization'
            
            if (errorMessage)
                return setMessage({ text: errorMessage, level: 'danger' })
            
            setMessage(null)
            
            await actions.setUserPassword(user.id, token, values.password)
            
            navigate('/signin', {
                state: {
                    token,
                },
            })
            
        },
    })
    
    const verify = useCallback(async token => {
        setUser(await actions.verifyEmailAddress(token))
        setVerified(true)
    }, [])
    
    useEffect(() => {
        const token = query.get('token')
        
        if (typeof token !== 'string') return
        
        verify(token)
        setToken(token)
        
    }, [query, verify])
    
    const { handleSubmit, handleChange } = formik
    
    return (
        <div className="flex items-center justify-center h-screen">
            <div className="w-1/2">
                <div className="flex flex-col items-center">
                    <img src="img/logo.png" className="w-1/2" alt="" />
                    <h3 className="mt-10">Please create your password</h3>
                    {verified && (<section className="mt-4 space-y-2">
                        {message && <Message message={message} />}            
                        <form onSubmit={handleSubmit} className="space-y-2">
                            <input
                                type="password"
                                name="password"
                                id="password"
                                onChange={handleChange}
                                placeholder="Password"
                                className="input input-bordered w-full"/>
                            <input
                                type="password"
                                name="confirmPassword"
                                id="confirm-password"
                                onChange={handleChange}
                                placeholder="Confirm Password"
                                className="input input-bordered w-full"/>
                            <div className="mb-4">
                                Password use 8 or more characters with a mix of letters, numbers & symbols.
                            </div>
                            <input
                                type="submit"
                                value="Save"
                                disabled={!token?.length || !verified}
                                className="btn btn-primary btn-block"/>
                        </form>
                    </section>)}
                </div>
            </div>
        </div>
    )
}

export default SetPassword
